module.exports = __webpack_public_path__ + "img/transmision-3.0d42d399.jpg";